import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import css from '@src/styles/components/form/control.scss';

export default class Radio extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            value: this.props.value ?? null,
        };
    }

    static get propTypes() {

        return {
            text: PropTypes.string,
            label: PropTypes.string,
            name: PropTypes.string,
            className: PropTypes.string,
            value: PropTypes.any,
            checked: PropTypes.bool,
        };
    }

    render() {

        const classes = [style('form-check', css) ];
        if (this.props.className != undefined)
            classes.push(this.props.className);

        return (
            <label className={ classes.join(' ') }>
                <input
                    type={ 'radio' }
                    name={ this.props.name }
                    value={ this.state.value }
                    defaultChecked={ this.props.checked } />
                { this.props.text }
            </label>
        );
    }
}